import { Component, Mixins } from 'vue-property-decorator';
import { PaymentRequirementsItem, PaymentRequirementsItemSignData } from '../../../api/incoming/payment-requirements-incoming.interface';
import { PaymentRequirementsDevice, PaymentRequirementsSignData } from '../interface';
import deviceInfo from '@/modules/Device/Device';
import { PaymentRequirementsIncomingStore } from '../../../store/incoming';
import { PaymentRequirementsIncomingGetter } from '../../../store/incoming/constants';
import PaymentRequirementsIncomingSignMapper from './PaymentRequirementsIncomingSignMapper';

@Component
export default class PaymentRequirementsIncomingSignData extends Mixins(
	PaymentRequirementsIncomingSignMapper
) {

	@PaymentRequirementsIncomingStore.Getter(
		PaymentRequirementsIncomingGetter.unprocessedList
	)
	readonly paymentRequirementsIncomingList!: PaymentRequirementsItem[]

	getPaymentRequirementsDataForSign(): PaymentRequirementsSignData {
		return {
			paymentRequirements: this.getPaymentRequirementsListForSign(),
			deviceInfo: this.getPaymentRequirementsDeviceForSign()
		};
	}

	getPaymentRequirementsListForSign(): PaymentRequirementsItemSignData[] {
		return this.paymentRequirementsIncomingList
			.map(this.mapPaymentRequirementsItemForSign.bind(this));
	}

	getPaymentRequirementsDeviceForSign(): PaymentRequirementsDevice {
		const { version, ...device } = deviceInfo;

		return {
			...device,
			appVersion: version
		};
	}

}